export const StubProjectsPageTexts = {
  thisPage: 'Aquesta pàgina',
  will: 'estarà',
  be: 'llesta',
  readySoon: 'en breu',
};
